export default __webpack_public_path__ + "static/socialtwitter-a88b454ff017b8058100f5e8ec6ab9d1.jpg";